var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5275 35H11.4717C10.9362 35 10.5005 34.608 10.5005 34.125V7.875C10.5005 7.392 10.9362 7 11.4717 7H19.2505V14.2625C19.2505 17.0135 21.3802 19.25 24 19.25H31.5005V34.125C31.5005 34.608 31.063 35 30.5275 35ZM30.8862 15.75H24C23.3105 15.75 22.7505 15.0833 22.7505 14.2625V7H22.9465L30.8862 15.75ZM34.5455 14.574L25.0185 4.074C24.6877 3.70825 24.217 3.5 23.7217 3.5H11.4717C9.00599 3.5 7.00049 5.4635 7.00049 7.875V34.125C7.00049 36.5365 9.00599 38.5 11.4717 38.5H30.5275C32.9932 38.5 35.0005 36.5365 35.0005 34.125V15.75C35.0005 15.3142 34.8377 14.896 34.5455 14.574Z",
    fill: "#D7D9E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFile);
export default __webpack_public_path__ + "static/media/defaultFile.4a740f858d99562c2ab58ed88cb7231c.svg";
export { ForwardRef as ReactComponent };